module.exports = __webpack_public_path__ + "img/Glosario_activo.80171e19.svg";